<mat-dialog-content *ngIf="loadData" >
    <!-- Angular Editor Supprimer -->
    <!-- <angular-editor [config]="editorConfig" placeholder=" "  #htmlEditor [(ngModel)]="myTable"></angular-editor> -->
    <!-- <ckeditor [config]="{}" #htmlEditor [(ngModel)] = "myTable" ></ckeditor> -->
    <!-- <ckeditor [config]="{ toolbar: [ 'heading', '|', 'bold', 'italic', 'link' , 'bulletedList', 'numberedList', 'blockQuote','tables' ] }"  data='
    <table border="1" cellpadding="1" cellspacing="1">
        <thead>
           <tr>
               <th colspan="2" style=" text-align: left;" >
                   <span style="font-weight: bold;"><font size="4">{{actionD.avtactionD[0].avtActionD_Code}}-{{actionD.avtactionD[0].avtActionD_Info}}</font></span><br>
                   <span style="font-weight: bold;">{{actionD.avtactionD[0].avtActionD_date.substring(0,10)}} de {{du.substring(0,5)}} à {{au.substring(0,5)}}</span><br>
                   <span style="font-weight: bold;"></span>
               </th>
           </tr>			 
        </thead>
        <tbody>
            <tr>
             <td style="text-align: center;" >
             <span style="font-weight: bold;">Actions</span></td>
             <td style="border-left:none;text-align: center;" >
             <span style="font-weight: bold;">Remarques générales </span></td>
            </tr>
            <tr style="mso-height-source:userset;" >             
             <td style="border-top:none;border-left:none;vertical-align:top;">{{actionD.avtactionD[0].avtActionD_suivi}} &nbsp;</td>
             <td style="border-top:none;border-left:none;vertical-align:top;" >{{actionD.avtactionD[0].avtActionD_remarque}} &nbsp;</td>
            </tr>
       </tbody>
   </table> 
    
    '> -->

</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button mat-primary"(click)="close()">Fermer</button>
    <button class="mat-raised-button mat-primary"(click)="save()">Enregistrer</button>
</mat-dialog-actions>